export default {
  tabs: {
    online_shop: 'Sklep online',
    reservations: 'Rezerwacje',
    storefront: 'Witryna',
  },
};
